import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { BosDurum, Buton, Iskelet, Secim } from "@koclukpanel/ui";
import { veliCocuklarim } from "./api";
import { KvkkBasvurularim } from "./KvkkBasvurularim";
import { TalepKutusu } from "./TalepKutusu";

/** F-PAR-10b / F-LGL-02b — kişisel başvuru çocuktan bağımsız, kurum talebi çocuk bağlamındadır. */
export function VeliHesabim() {
  const [ekran, setEkran] = useState<"hesap" | "talep" | "kvkk">("hesap");
  if (ekran === "hesap") {
    return (
      <div className="flex flex-col gap-3">
        <h2>Hesabım</h2>
        <Buton gorunum="ikincil" onClick={() => setEkran("talep")}>
          Kuruma talep
        </Buton>
        <Buton gorunum="ikincil" onClick={() => setEkran("kvkk")}>
          KVKK başvurularım
        </Buton>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-3">
      <Buton gorunum="sessiz" onClick={() => setEkran("hesap")}>
        ← Hesabım
      </Buton>
      {ekran === "kvkk" ? <KvkkBasvurularim /> : <VeliTalepleri />}
    </div>
  );
}

function VeliTalepleri() {
  const [ogrenciId, setOgrenciId] = useState("");
  const cocuklar = useQuery({ queryKey: ["veli-cocuklarim"], queryFn: veliCocuklarim });
  if (cocuklar.isPending) return <Iskelet satir={3} />;
  if (cocuklar.isError) {
    return (
      <BosDurum
        baslik="Bağlı çocuklar alınamadı"
        eylem={<Buton onClick={() => void cocuklar.refetch()}>Tekrar dene</Buton>}
      />
    );
  }
  if (!cocuklar.data.length) {
    return (
      <BosDurum baslik="Bağlı öğrenci yok" aciklama="Talep açmak için kurumla iletişime geçin." />
    );
  }
  const secili = cocuklar.data.find((c) => c.id === ogrenciId) ?? cocuklar.data[0]!;
  return (
    <>
      <Secim
        etiket="Talebin ilgili olduğu çocuk"
        value={secili.id}
        onChange={(e) => setOgrenciId(e.target.value)}
      >
        {cocuklar.data.map((c) => (
          <option key={c.id} value={c.id}>
            {c.ad}
          </option>
        ))}
      </Secim>
      <TalepKutusu key={secili.id} ogrenciId={secili.id} />
    </>
  );
}
